import styled from 'styled-components';
import PropTypes from "prop-types";
import { device } from "../device";

const H5 = styled.h4`
    font-size: 18px;
    font-weight: 500;
    line-height: 1.2;

    margin: ${({space}) => 
        (space === 'Top' && '64px 0 0') ||
        (space === 'TopDown' && '64px 0 16px') || 
        (space === 'Down' && '0 0 16px') || 
        '0'
    };

    @media ${device.lg} {
        font-size: 24px;
    }
`;

H5.propTypes = {
    space: PropTypes.string
};

export default H5;